export class StorageKeys {
	static CART = 'SSSC_CART';
	static PRE_ORDER = 'SSSC_PRE_ORDER';
	static UserToken = 'SSSC_USER_TOKEN';
}
